<template>
  <div >
      <el-form inline size="small">
        <el-form-item label="关键词">
          <el-input v-model="searchParams.word" placeholder="请输入" size="small" clearable ></el-input>
        </el-form-item>
<!--        <el-form-item label="类型">
          <el-select v-model="searchParams.type" clearable placeholder="全部" class="w_120">
            <el-option v-for="item in Object.keys(typeList)" :value="item" :label="typeList[item].label" :key="item" ></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="检测词分类">
          <!-- <el-select v-model="searchParams.lexicon_type" clearable placeholder="全部" class="w_120">
            <el-option v-for="item in Object.keys(lexiconType)" :value="item" :label="lexiconType[item].label" :key="item" ></el-option>
          </el-select> -->
          <el-select v-model="searchParams.lexicon_type" clearable placeholder="全部" class="w_220" multiple collapse-tags>
            <el-option v-for="item in dictionaryWordsList" :value="item.id" :label="item.dictionary_name" :key="item.id">
                <span style="float: left" >{{ item.dictionary_name }}</span>
                <span style="float: right; color: #e6a23c; font-size: 13px" v-if="item.merchant_id === 0">系统</span>
                <span style="float: right; color: #017eff; font-size: 13px" v-else>自配</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
          <el-button size="small" @click="refresh">重置</el-button>
        </el-form-item>
      </el-form>
    <div style="margin-bottom: 15px;">
      <el-button type="primary" plain :disabled="!selectData.length" size="small" @click="batchDelete">批量删除</el-button>
      <el-button type="success" size="small" @click="handleAdd">批量新增</el-button>
      <el-button type="warning" plain size="small" @click="handleCheck">提交检测</el-button>
      <el-button size="small" @click="jumpToLog">检测记录</el-button>

      <el-button type="success" size="small" @click="handleDictionAdd">检测词分类管理</el-button>

    </div>
    <el-table v-loading="loading" :data="tableData" @selection-change="selectChange"
              :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="rc_table" row-key="id" >
      <el-table-column type="selection" align="center"  width="50" :selectable="checkSelectable"></el-table-column>
      <el-table-column label="序号" type="index" align="center" width="80"></el-table-column>
      <el-table-column label="关键词" prop="word" align="center"></el-table-column>
      <el-table-column label="分类" prop="status" align="center" >
        <template #default="{ row }">
          <el-tag size="small">{{ row.merchant_id === 0 ? '系统': '自配' }}</el-tag>
        </template>
      </el-table-column>
<!--      <el-table-column label="类型" prop="status" align="center" >
        <template #default="{ row }">
          <el-tag :type="typeList[row.type].type" size="small">{{typeList[row.type].label}}</el-tag>
        </template>
      </el-table-column>-->
      <el-table-column label="检测词分类" prop="status" align="center" >
        <template #default="{ row }">
          <el-tag size="small">{{ dictionaryWordsList.find(item => item.id === row.lexicon_type)?.dictionary_name || '未知' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="created_at" align="center"></el-table-column>

    </el-table>

    <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getDataList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total>0" />

    <el-dialog title="新增关键词" :visible.sync="addShow" :close-on-click-modal="false">
      <el-form :model="addInfo" ref="addForm" label-width="100px" size="small">
<!--        <el-form-item label="类型" prop="type" :rules="[{ required: true, message: '请选择类型', trigger: 'change' }]">
          <el-select v-model="addInfo.type">
            <el-option v-for="item in Object.keys(typeList)" :value="item" :label="typeList[item].label" :key="item" ></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="检测词分类" prop="lexicon_type" :rules="[{ required: true, message: '请选择检测词分类', trigger: 'change' }]">
          <!-- <el-select v-model="addInfo.lexicon_type">
            <el-option v-for="item in Object.keys(lexiconType)"  :value="item" :label="lexiconType[item].label" :key="item" ></el-option>
          </el-select> -->
          <el-select v-model="addInfo.lexicon_type">
            <el-option v-for="item in dictionaryWordsList" :value="item.id" :label="item.dictionary_name" :key="item.id" v-if="item.merchant_id !== 0 || ismanager">
                <span style="float: left" >{{ item.dictionary_name }}</span>
                <span style="float: right; color: #e6a23c; font-size: 13px" v-if="item.merchant_id === 0">系统</span>
                <span style="float: right; color: #017eff; font-size: 13px" v-else>自配</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关键词" prop="keywords" :rules="[{ required: true, message: '请填写关键词', trigger: 'change', }]">
          <el-input type="textarea" :autosize="{minRows: 5,maxRows: 20}" v-model="addInfo.keywords" placeholder="填写格式示例：
测试1
测试2
测试3" size="small" clearable ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="addShow = false">取消</el-button>
        <el-button type="primary" @click="submitAdd" :loading="addLoading">确定</el-button>
      </template>
    </el-dialog>
    <el-dialog title="检测关键词" :visible.sync="checkShow" :close-on-click-modal="false" width="500px">
      <el-form :model="checkInfo" ref="checkForm" label-width="100px" size="small">
        <el-form-item label="检测词分类" prop="lexicon_type">
          <!-- <el-select v-model="addInfo.lexicon_type">
            <el-option v-for="item in Object.keys(lexiconType)"  :value="item" :label="lexiconType[item].label" :key="item" ></el-option>
          </el-select> -->
          <el-select v-model="checkInfo.lexicon_type" clearable multiple collapse-tags placeholder="全部">
            <el-option v-for="item in dictionaryWordsList" :value="item.id" :label="item.dictionary_name" :key="item.id">
                <span style="float: left" >{{ item.dictionary_name }}</span>
                <span style="float: right; color: #e6a23c; font-size: 13px" v-if="item.merchant_id === 0">系统</span>
                <span style="float: right; color: #017eff; font-size: 13px" v-else>自配</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品渠道" prop="channel" :rules="[{ required: true, message: '请选择商品渠道', trigger: 'change' }]">
          <el-select v-model="checkInfo.channel">
            <el-option v-for="item in Object.keys(channeList)" :value="item" :label="channeList[item].label" :key="item" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品分组">
          <el-select v-model="checkInfo.group_id" filterable clearable multiple collapse-tags placeholder="全部" @change="changeGroupIds">
            <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品子分组">
          <el-select v-model="checkInfo.child_group_id" filterable clearable multiple collapse-tags placeholder="全部" >
            <el-option v-for="group in child_groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="检测方式" prop="detection_method" :rules="[{ required: true, message: '请选择检测方式', trigger: 'change' }]">
          <el-select v-model="checkInfo.detection_method">
            <el-option v-for="item in Object.keys(methodList)" :value="item" :label="methodList[item].label" :key="item" ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="checkShow = false">取消</el-button>
        <el-button type="primary" @click="submitCheck" :loading="checkLoading">确定</el-button>
      </template>
    </el-dialog>
    <DictionaryWords @dataChange="initData" :dialog_visible.sync="dictionary_dialog_visible" :dictionary_type="1" :initList.sync="dictionaryWordsList"></DictionaryWords>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";

import Pagination from "@/components/pagination/pagination.vue";
import DictionaryWords from "@/components/dictionaryWords/dictionaryWords.vue";

export default {
  components: {
    Pagination,
    DictionaryWords,
  },
  computed:{
    ...mapState({
        users:(state)=>state.login.userinfo
    })
  },
  data() {
    return {
      dataInfo:{},
      loading: false,
      tableData: [],
      page_data: {
        limit: 10,
        page: 1,
        total:0,
      },
      searchParams:{
        word:'',
        type:'',
        lexicon_type:''
      },
      selectData:[],
      lexiconType:{
        1: {label:'违禁词',type:'error'},
        2: {label:'极限词',type:'warning'},
        3: {label:'品牌词',type:'info'},
      },
      typeList:{
        1: {label:'过滤词',type:'success'},
        2: {label:'下架词',type:'error'},
      },
      addShow:false,
      addInfo:{type:'',lexicon_type:"",keywords:""},
      addLoading:false,

      checkShow:false,
      checkLoading:false,
      checkInfo:{lexicon_type:[], channel:'1',detection_method :'2',group_id:'',child_group_id:[]},
      channeList:{
        1: {label:'云商品库'},
        // 2: {label:'草稿箱'},
        // 3: {label:'仓库中'},
        // 4: {label:'上架中'},
      },
      methodList:{
        1: {label:'全量检测'},
        2: {label:'未检测数据'},
      },
      groupList:[],
      child_groupList:[],
      dictionaryWordsList:[],
      dictionary_dialog_visible: false,
      ismanager: false,
    }
  },
  created() {
    this.ismanager = this.users.mer_user_id === '1'
  },
  methods: {
    ...mapActions({
      getKeywordList: 'ucenter/getKeywordList',
      opKeywordAdd: 'ucenter/opKeywordAdd',
      opKeywordDelete: 'ucenter/opKeywordDelete',
      opSubmitDetection: 'ucenter/opSubmitDetection',
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      opGetDictionaryWords: 'ucenter/opGetDictionaryWords',
    }),
    initData(){
          this.getGroupList()
      this.refresh()
      this.getDictionaryWords()
    },
    checkSelectable(row){
        if (row.merchant_id === 0) {
            return this.ismanager === true;
        }
        return true;
    },
    //获取盲盒列表
    getDataList() {
      this.loading = true
      let param = {page_size:this.page_data.limit,page:this.page_data.page,batch_id:this.batchId,...this.searchParams}
      this.getKeywordList({
        data: param,
        success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list
            this.page_data.total = res.data.total
          } else {
            this.$message.error(res.message)
          }

        }
      })
    },
    getDictionaryWords() {
      this.opGetDictionaryWords({
        data: {'dictionary_type': 1},
        success: (res) => {
          if (res.code == 200) {
            let list = res.data || [];
            list.sort((a, b) => (a.merchant_id === 0 ? -1 : 0));
            this.dictionaryWordsList = list;
            // this.dictionaryWordsList = res.data || []
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleSearch(){
      this.page_data.page = 1
      this.getDataList()
    },
    refresh(){
      this.page_data.page = 1
      this.page_data.total = 0
      this.searchParams = {
        word:'',
        type:'',
        lexicon_type:''
      }
      this.getDataList()
    },
    selectChange(e){
      this.selectData = [...e]
    },
    // 获取分组列表
    getGroupList() {
      this.getCloudProductGroups({
        data: { with_count: 0 },
        success: (res) => {
          if (res.code === 200) {
            this.groupList = res.data || []
          }
        }
      })
    },
    //批量删除
    batchDelete(){
      this.$confirm(`是否确定删除${this.selectData.length}个关键词?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opKeywordDelete({
          data: {ids:this.selectData.map(item=>item.id).join(',')},
          success: (res) => {
            if (res.code == 200) {
              this.$message.success('删除成功')
              this.getDataList()
            } else {
              this.$message.error(res.message)
            }
          }
        })
      })
    },

    // === 新增 ===
    handleAdd(){
      this.addShow = true
      this.addInfo = {type:'',lexicon_type:"",keywords:""}
     this.$nextTick(()=>{
       this.$refs.addForm.resetFields()
     })
    },
    handleDictionAdd(){
        this.dictionary_dialog_visible = true;
    },
    submitAdd(){
      this.$refs.addForm.validate(valid => {
        if(valid){
          const words = this.addInfo.keywords.split(/\r\n|\r|\n|,|，/g).map(item => item.trim()).filter(item => item !== '')
          const params = {
            // type:  this.addInfo.type,
            lexicon_type:  this.addInfo.lexicon_type,
            words: words.join(',')
          }
          this.addLoading = true
          this.opKeywordAdd({
            data: params,
            success: (res) => {
              if (res.code == 200) {
                this.$message.success('添加成功')
                this.addShow = false
                this.refresh()
              } else {
                this.$message.error(res.message)
              }
              this.addLoading = false
            }
          })
        }
      })

    },

    // === 检测关键词 ===
    handleCheck(){
      this.checkShow = true
      this.checkInfo = {lexicon_type:[], channel:'1',detection_method:'2',group_id:'', child_group_id: []}
      this.checkLoading =false
      this.$nextTick(()=>{
        this.$refs.checkForm.resetFields()
      })
    },
    submitCheck(){
      this.$refs.checkForm.validate(valid => {
        if( valid){
          this.checkLoading = true
          this.opSubmitDetection({
            data: this.checkInfo,
            success: (res) => {
              this.checkLoading = false
              if (res.code == 200) {
                this.$message.success('检测提交成功')
                this.checkShow = false
                this.jumpToLog()
              } else {
                this.$message.error(res.message)
              }

            },
            fail: (res) => {
              this.checkLoading = false
            }
          })
        }
      })
    },

    //检测记录
    jumpToLog(){
      this.$router.push({
        path: '/uc_check_keywordLog',
        query: {
          menuId:132
        }
      })
    },
    changeGroupIds(val) {
        this.$set(this.checkInfo, 'child_group_id', '')
        this.child_groupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
    },
  }
}
</script>


<style scoped>
.w_120{
  width: 150px;
}
.w_220{
  width: 220px;
}
</style>
